<template>
  <div class="studio-calendar studio-page">
    <div class="container text-center">
      <div class="row" v-if="isLoading">
        <div class="col-12">
          <HMSpinner />
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 position-static">
          <FullEventsCalendar :calendarEvents="calendarEvents" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'studio-calendar',

  isStudio: true,
  hideInstagramSlider: true,
})
</script>

<script lang="ts">
import { mapState } from 'pinia';
import { useStudioStore } from '@/stores';
import FullEventsCalendar from '@/components/events/FullEventsCalendar.vue';
import { errorToMessage } from '@/utils/errors';
import RefreshData from '@/mixins/refreshData';

export default {
  name: 'StudioCalendar',
  mixins: [RefreshData],
  components: {
    FullEventsCalendar,
  },
  computed: {
    ...mapState(useStudioStore, {
      calendarEvents: 'studioEvents',
    }),
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        await useStudioStore().getStudioEvents(this.$studioURL);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load studio events',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped></style>
